import { CarouselManager } from "../utils/carouselManager";

class GCarousel extends HTMLElement {
  constructor() {
    super();

    this.splideEl = this.querySelector(".splide");
  }

  async connectedCallback() {
    await this.initSlider();
  }

  async fetchItems() {
    var url = `${window.Shopify.routes.root}search?section_id=${this.dataset.sectionId}`;
    const response = await fetch(url);
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    const sectionSelector = this.id ? `#${this.id}` : "g-carousel";
    const section = tempDiv.querySelector(sectionSelector);
    const newsplideList = section.querySelector(".splide__list");
    if (newsplideList.childElementCount > 0) {
      this.splideList.innerHTML = newsplideList.innerHTML;
    } else {
      this.setAttribute("aria-hidden", true);
    }
  }

  async initSlider() {
    let options = {};
    if (this.dataset.sliderOptions) {
      options = JSON.parse(this.dataset.sliderOptions);
    }

    const fetchItemsPromise = new Promise((resolve) => {
      if (this.dataset.lazyloadSection === "true" || this.dynamic) {
        const handler = async () => {
          await this.fetchItems();
          if (this.splide) {
            this.splide.refresh();
          }
          this.splideEl.removeEventListener("carousel:start-mount", handler);
          resolve();
        };

        this.splideEl.addEventListener("carousel:start-mount", handler);
      } else {
        resolve();
      }
    });

    // Let CarouselManager handle initialization and observation
    const [_, carouselInstance] = await Promise.all([
      fetchItemsPromise,
      CarouselManager.create(this.splideEl, options),
    ]);
    this.splide = carouselInstance;
    this.splide.refresh();

    this.initWheel();
    if (this.dataset.arrows === "true") {
      this.initSliderArrows();
    }
    if (this.dataset.progressBar) {
      this.initSliderProgressBar();
    }
    this.classList.add("js-loaded");
  }

  initWheel() {
    let lastTime = 0;
    const min = this.splide.options.wheelMinThreshold || 0;
    const sleep = this.splide.options.wheelSleep || 80;

    this.splideEl.addEventListener("wheel", (e) => {
      if (window.innerWidth < 640) return;
      if (e.cancelable) {
        let delta = e.deltaX;

        if (e.shiftKey && delta === 0) {
          delta = e.deltaY;
        }

        const backwards = delta < 0;
        const timeStamp = Date.now();
        if (Math.abs(delta) > min) {
          e.preventDefault();
          if (timeStamp - lastTime > sleep) {
            this.splide.go(backwards ? "<" : ">");
            lastTime = timeStamp;
          }
        }
      }
    });
  }

  initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      const maxIndex = () => {
        const maxIndex = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();

        if (maxIndex === currentIndex) {
          return true;
        } else if (maxIndex < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex);
          return true;
        } else {
          return false;
        }
      };

      navNextBtn.addEventListener("click", () => {
        if (maxIndex()) return;
        this.splide.go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }

  // allowSidewaysScroll(element, splide) {
  //   let lastScrollTime = 0;
  //   let deltaAccumulator = 0;
  //   const scrollThreshold = 50; // Adjust based on sensitivity
  //   const cooldown = 300; // ms

  //   element.addEventListener(
  //     "wheel",
  //     function (event) {
  //       if (event.ctrlKey) return;

  //       const now = Date.now();
  //       const deltaX = event.deltaX;
  //       const deltaY = event.deltaY;

  //       // Shift+Scroll for horizontal scroll on Windows
  //       if (event.shiftKey && Math.abs(deltaX) === 0) {
  //         event.preventDefault();

  //         if (deltaY > 0) {
  //           splide.go(">");
  //         } else if (deltaY < 0) {
  //           splide.go("<");
  //         }
  //         return;
  //       }

  //       // Ignore vertical dominant scrolling
  //       if (Math.abs(deltaY) > Math.abs(deltaX)) return;

  //       // Prevent default behavior when at scroll edges
  //       const scrollLeftMax = element.scrollWidth - element.offsetWidth;
  //       const nextScroll = element.scrollLeft + deltaX;

  //       if (nextScroll < 0 || nextScroll > scrollLeftMax) {
  //         event.preventDefault();
  //       }

  //       // Accumulate delta to wait until threshold is passed
  //       deltaAccumulator += deltaX;

  //       if (Math.abs(deltaAccumulator) >= scrollThreshold && now - lastScrollTime > cooldown) {
  //         if (deltaAccumulator > 0) {
  //           splide.go(">");
  //         } else {
  //           splide.go("<");
  //         }

  //         deltaAccumulator = 0;
  //         lastScrollTime = now;
  //       }
  //     },
  //     { passive: false }
  //   );
  // }

  get visibleSlides() {
    if (!this.splide) return 1;
    if (!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length;
    }
    return this._visibleSlides;
  }

  initSliderProgressBar() {
    const progress = this.splide.root.querySelector(".js-slider-progress");
    const bar = progress?.querySelector(".js-slider-progress-bar");
    let visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length;

    if (progress && bar) {
      const updateProgress = () => {
        const end = this.splide.Components.Controller.getEnd() + 1;
        const rate = Math.min((this.splide.index + visibleSlides + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      };

      updateProgress();
      progress.setAttribute("aria-hidden", false);

      this.splide.on("move scrolled", updateProgress);
    }

    document.addEventListener(
      "resize",
      () => (visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length)
    );
  }

  refresh() {
    if (this.splide) {
      this.splide.refresh();
    }
  }

  get splideList() {
    if (!this._splideList) {
      this._splideList = this.querySelector(".splide__list");
    }
    return this._splideList;
  }
}

export default GCarousel;
customElements.define("g-carousel", GCarousel);
